var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 25,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M 0 0 h 31 v 25 H 0 z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.5,3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#08815c",
    d: "M 18.8 13.9 l -2.3 -5.2 l 10.6 -3.9 l 2.2 4.2 l -10.5 5 z m 7.9 4.1 l -10.5 5.1 V 11.8 l 1.5 3.4 a 0.7 0.7 0 0 0 1 0.4 l 7.9 -3.8 v 6.2 z m -22.4 0 v -6.2 l 7.9 3.7 a 0.7 0.7 0 0 0 1 -0.4 l 1.6 -3.5 v 11.4 L 4.3 18.1 z M 3.9 4.8 l 10.6 3.9 l -2.3 5.2 L 1.7 9 l 2.2 -4.2 z M 15.5 1.5 l 9.5 2.6 L 15.5 7.6 L 6 4.1 l 9.6 -2.6 z m 15.4 7.5 L 28.1 3.6 a 0.7 0.7 0 0 0 -0.4 -0.4 l 0 0 L 15.7 0 a 0.7 0.7 0 0 0 -0.4 0 L 3.4 3.2 l 0 0 a 0.7 0.7 0 0 0 -0.5 0.4 L 0.1 9 a 0.7 0.7 0 0 0 0.3 1 L 2.9 11.2 v 7.4 c 0 0.3 0.2 0.5 0.4 0.7 l 11.9 5.8 a 0.7 0.7 0 0 0 0.6 0 h 0 l 11.9 -5.8 a 0.7 0.7 0 0 0 0.4 -0.7 v -7.4 v 0 l 2.4 -1.1 a 0.7 0.7 0 0 0 0.3 -1 z",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/box-icon.c2d88f41e7605f7c8d4fb35db54c736a.svg";
export { ForwardRef as ReactComponent };